<template>
  <span class="badge-icon">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: "BadgeIcon",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.badge-icon {
  border-radius: 4px;
  display: inline-block;
  vertical-align: bottom;
  &.-requires {
    background-color: $danger;
    color: $white;
    min-width: 30px;
    @include mq-up(md) {
      min-width: 36px;
    }
  }
  &.-changed {
    border: 1px solid $danger;
    background-color: $white;
    color: $danger;
  }
  &.-sm {
    font-size: 10px;
    padding: 2px 4px 1px;
    font-weight: normal;
    @include mq-up(md) {
      font-size: 13px;
      padding: 6px 5px 0;
      min-height: 24px;
      line-height: 100%;
    }
  }
  &.-md {
    font-size: 12px;
    line-height: 19px;
    font-weight: normal;
    padding: 2px 10px 0;
    @include mq-up(md) {
      font-size: 16px;
      line-height: 26px;
      padding: 2px 18px 0;
    }
  }
  &.-lg {
    font-size: 16px;
    padding: 3px 6px;
    font-weight: normal;
    @include mq-up(md) {
      font-size: 16px;
      line-height: 16px;
    }
  }
}
</style>
